const getFilePath = (file)=>{
    if(process.env.REACT_APP_FILES_LOCATIONS==='s3' && file['webLocation']){
      return file.webLocation
    }
    return file.location
}
export default getFilePath
